const aid = process.env.REACT_APP_AID || 0;
const platform = process.env.REACT_APP_PLATFORM || "master";

// 配置信息
const config = {
  master: {
    0: {
      loginIcon: "https://zhaixing-dev-00.oss-cn-shanghai.aliyuncs.com/public/F0BE4D91-CCEE-4C5D-B092-41D28F718A96.png",
      logo: "https://zhaixing-dev-00.oss-cn-shanghai.aliyuncs.com/public/C5051809-9635-4C8D-8B35-77532DA772AB.png",
      text: "摘星方舟",
      basePassword: "Zx123456@", // 默认密码
      names: {
        web: "摘星方舟",
        sj: "摘星搜荐",
        geo: "摘星GEO",
      },
      productTree: [
        {
          title: "摘星搜荐",
          key: "all",
          children: [
            { title: "GEO", key: "geo" },
            { title: "短视频 SEO", key: "short-video-seo" },
            { title: "搜索引擎 SEO", key: "search-engine-seo" },
          ],
        },
      ],
      productOptions: [
        { label: "全部", value: 0 },
        { label: "摘星方舟", value: 2 },
        { label: "摘星搜荐", value: 1 },
        { label: "摘星GEO", value: 3 },
      ],
    },
    1002: {
      loginIcon: "https://zhaixing-dev-00.oss-cn-shanghai.aliyuncs.com/public/logo-banner.png",
      logo: "https://zhaixing-dev-00.oss-cn-shanghai.aliyuncs.com/public/15BABDC7-F6FD-4A98-B72D-F021978E14B7.png",
      text: "云视AI获客",
      basePassword: "Ys123456@", // 默认密码
      names: {
        web: "云视AI获客",
        sj: "云视搜荐",
        geo: "云视GEO",
      },
      productTree: [
        {
          title: "云视搜荐",
          key: "all",
          children: [
            { title: "GEO", key: "geo" },
            { title: "短视频 SEO", key: "short-video-seo" },
            { title: "搜索引擎 SEO", key: "search-engine-seo" },
          ],
        },
      ],
      productOptions: [
        { label: "全部", value: 0 },
        { label: "云视AI获客", value: 2 },
        { label: "云视搜荐", value: 1 },
        { label: "云视GEO", value: 3 },
      ],
    },
  },
  "51wl": {
    1002: {
      loginIcon: "https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/2.png",
      logo: "https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/51wl/2.png",
      text: "搜索排名",
      basePassword: "Ss123456@", // 默认密码
      names: {
        web: "搜索排名",
        sj: "搜索排名搜荐",
        geo: "搜索排名GEO",
      },
      productTree: [
        {
          title: "搜索排名",
          key: "all",
          children: [
            { title: "GEO", key: "geo" },
            { title: "短视频 SEO", key: "short-video-seo" },
            { title: "搜索引擎 SEO", key: "search-engine-seo" },
          ],
        },
      ],
      productOptions: [
        { label: "全部", value: 0 },
        { label: "搜索排名", value: 2 },
        { label: "搜索排名搜荐", value: 1 },
        { label: "搜索排名GEO", value: 3 },
      ],
    },
  },
  fengyin: {
    1002: {
      loginIcon: "https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/2.png",
      logo: "https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/fengyin/2.png",
      text: "云视搜索",
      basePassword: "Ys123456@", // 默认密码
      names: {
        web: "云视搜索",
        sj: "云视搜索搜荐",
        geo: "云视搜索GEO",
      },
      productTree: [
        {
          title: "云视搜索",
          key: "all",
          children: [
            { title: "GEO", key: "geo" },
            { title: "短视频 SEO", key: "short-video-seo" },
            { title: "搜索引擎 SEO", key: "search-engine-seo" },
          ],
        },
      ],
      productOptions: [
        { label: "全部", value: 0 },
        { label: "云视搜索", value: 2 },
        { label: "云视搜索搜荐", value: 1 },
        { label: "云视搜索GEO", value: 3 },
      ],
    },
  },
  juyuai: {
    1002: {
      loginIcon: "https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/2.png",
      logo: "https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/juyuai/2.png",
      text: "巨宇AI获客",
      basePassword: "Jy123456@", // 默认密码
      names: {
        web: "巨宇AI获客",
        sj: "巨宇AI获客搜荐",
        geo: "巨宇AI获客GEO",
      },
      productTree: [
        {
          title: "巨宇AI获客",
          key: "all",
          children: [
            { title: "GEO", key: "geo" },
            { title: "短视频 SEO", key: "short-video-seo" },
            { title: "搜索引擎 SEO", key: "search-engine-seo" },
          ],
        },
      ],
      productOptions: [
        { label: "全部", value: 0 },
        { label: "巨宇AI获客", value: 2 },
        { label: "巨宇AI获客搜荐", value: 1 },
        { label: "巨宇AI获客GEO", value: 3 },
      ],
    },
  },
  qiteng518: {
    1002: {
      loginIcon: "https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/2.png",
      logo: "https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/qiteng518/2.png",
      text: "剪辑系统",
      basePassword: "Jj123456@", // 默认密码
      names: {
        web: "剪辑系统",
        sj: "剪辑系统搜荐",
        geo: "剪辑系统GEO",
      },
      productTree: [
        {
          title: "剪辑系统",
          key: "all",
          children: [
            { title: "GEO", key: "geo" },
            { title: "短视频 SEO", key: "short-video-seo" },
            { title: "搜索引擎 SEO", key: "search-engine-seo" },
          ],
        },
      ],
      productOptions: [
        { label: "全部", value: 0 },
        { label: "剪辑系统", value: 2 },
        { label: "剪辑系统搜荐", value: 1 },
        { label: "剪辑系统GEO", value: 3 },
      ],
    },
  },
  tui55: {
    1002: {
      loginIcon: "https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/1.png",
      logo: "https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/tui55/1.png",
      text: "千里马AI获客",
      basePassword: "Qlm123456@", // 默认密码
      names: {
        web: "千里马AI获客",
        sj: "千里马AI获客搜荐",
        geo: "千里马AI获客GEO",
      },
      productTree: [
        {
          title: "千里马AI获客",
          key: "all",
          children: [
            { title: "GEO", key: "geo" },
            { title: "短视频 SEO", key: "short-video-seo" },
            { title: "搜索引擎 SEO", key: "search-engine-seo" },
          ],
        },
      ],
      productOptions: [
        { label: "全部", value: 0 },
        { label: "千里马AI获客", value: 2 },
        { label: "千里马AI获客搜荐", value: 1 },
        { label: "千里马AI获客GEO", value: 3 },
      ],
    },
  },
  pbinfo: {
    1002: {
      loginIcon: "https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/pbinfo/1.png ",
      logo: "https://ysai-00.oss-cn-shanghai.aliyuncs.com/public/tiepai/pbinfo/1.png ",
      text: "鹏博资讯",
      basePassword: "Qlm123456@", // 默认密码
      names: {
        web: "鹏博资讯",
        sj: "鹏博资讯搜荐",
        geo: "鹏博资讯GEO",
      },
      productTree: [
        {
          title: "鹏博资讯",
          key: "all",
          children: [
            { title: "GEO", key: "geo" },
            { title: "短视频 SEO", key: "short-video-seo" },
            { title: "搜索引擎 SEO", key: "search-engine-seo" },
          ],
        },
      ],
      productOptions: [
        { label: "全部", value: 0 },
        { label: "鹏博资讯", value: 2 },
        { label: "鹏博资讯搜荐", value: 1 },
        { label: "鹏博资讯GEO", value: 3 },
      ],
    },
  },
};
const platformConfig = config[platform] || config.master;
export const aidConfig = platformConfig[aid] || platformConfig[0];

// 地址信息
const url = {
  master: {
    0: {
      dev: {
        web: "https://zxfz.zxaigc.com",
        sj: "https://dev.sj.zxaigc.com",
        geo: "https://dev.geo.zxaigc.com",
        crm: "https://dev.agent.zxaigc.com",
        matrix: "https://zxfz.zxaigc.com",
        socket: "https://zxfz.zxaigc.com",
        geo_share: "https://dev.geo.share.zxaigc.com",
      },
      prod: {
        web: "https://www.zxaigc.com",
        sj: "https://sj.zxaigc.com",
        geo: "https://geo.zxaigc.com",
        crm: "https://agent.zxaigc.com",
        matrix: "https://www.zxaigc.com",
        socket: "https://www.zxaigc.com",
        geo_share: "https://geo.share.zxaigc.com",
      },
    },
    1002: {
      dev: {
        web: "https://dev.yunshi.zxaigc.com",
        sj: "https://dev.sj.yunshiyouke.com.cn",
        geo: "https://dev.aigeo.yunshiyouke.com.cn",
        crm: "https://aiagent.yunshiyouke.com.cn",
        matrix: "https://dev.yunshi.matrix.zxaigc.com",
        socket: "https://dev.yunshi.zxaigc.com",
        geo_share: "https://dev.geo.share.yunshiyouke.com.cn",
      },
      prod: {
        web: "https://ai.yunshiyouke.com.cn",
        sj: "https://sj.yunshiyouke.com.cn",
        geo: "https://aigeo.yunshiyouke.com.cn",
        crm: "https://ag.yunshiyouke.com.cn",
        matrix: "https://matrix.yunshiyouke.com.cn",
        socket: "https://ai.yunshiyouke.com.cn",
        geo_share: "https://geo.share.yunshiyouke.com.cn",
      },
    },
  },
  "51wl": {
    1002: {
      dev: {
        web: "https://spuser.51wl.cn",
        crm: "https://spagent.51wl.cn",
        matrix: "https://matrix.51wl.cn",
        socket: "https://ai.yunshiyouke.com.cn",
      },
      prod: {
        web: "https://spuser.51wl.cn",
        crm: "https://spagent.51wl.cn",
        matrix: "https://matrix.51wl.cn",
        socket: "https://ai.yunshiyouke.com.cn",
      },
    },
  },
  fengyin: {
    1002: {
      dev: {
        web: "https://custom.fengyin.tv",
        crm: "https://daili.fengyin.tv",
        matrix: "https://matrix.fengyin.tv",
        socket: "https://ai.yunshiyouke.com.cn",
      },
      prod: {
        web: "https://custom.fengyin.tv",
        crm: "https://daili.fengyin.tv",
        matrix: "https://matrix.fengyin.tv",
        socket: "https://ai.yunshiyouke.com.cn",
      },
    },
  },
  juyuai: {
    1002: {
      dev: {
        web: "https://www.juyuai.cn",
        crm: "https://admin.juyuai.cn",
        matrix: "https://matrix.juyuai.cn",
        socket: "https://ai.yunshiyouke.com.cn",
      },
      prod: {
        web: "https://www.juyuai.cn",
        crm: "https://admin.juyuai.cn",
        matrix: "https://matrix.juyuai.cn",
        socket: "https://ai.yunshiyouke.com.cn",
      },
    },
  },
  qiteng518: {
    1002: {
      dev: {
        web: "https://member.qiteng518.com",
        crm: "https://agentx.qiteng518.com",
        matrix: "https://matrix.qiteng518.com",
        socket: "https://ai.yunshiyouke.com.cn",
      },
      prod: {
        web: "https://member.qiteng518.com",
        crm: "https://agentx.qiteng518.com",
        matrix: "https://matrix.qiteng518.com",
        socket: "https://ai.yunshiyouke.com.cn",
      },
    },
  },
  tui55: {
    1002: {
      dev: {
        web: "https://fuwu.tui55.com",
        crm: "https://agent.tui55.com",
        matrix: "https://matrix.tui55.com",
        socket: "https://ai.yunshiyouke.com.cn",
      },
      prod: {
        web: "https://fuwu.tui55.com",
        crm: "https://agent.tui55.com",
        matrix: "https://matrix.tui55.com",
        socket: "https://ai.yunshiyouke.com.cn",
      },
    },
  },
  pbinfo: {
    1002: {
      dev: {
        web: "https://ai.pbinfo.cn",
        crm: "https://pbagent.pbinfo.cn",
        matrix: "https://matrix.pbinfo.cn",
        socket: "https://ai.yunshiyouke.com.cn",
      },
      prod: {
        web: "https://ai.pbinfo.cn",
        crm: "https://pbagent.pbinfo.cn",
        matrix: "https://matrix.pbinfo.cn",
        socket: "https://ai.yunshiyouke.com.cn",
      },
    },
  },
};
const platformUrl = url[platform] || url.master;
const aidUrl = platformUrl[aid] || platformUrl[0];
let env = "dev";
if (+aid === 1002) {
  env = location.host.includes("aiagent") ? "dev" : "prod";
} else {
  env = location.host.includes("dev") ? "dev" : "prod";
}
export const envUrl = aidUrl[env] || aidUrl.dev;
export const masterUrl = url.master;
